import { Middleware } from 'redux';

import { loadRoomSuccess, LOAD_ROOM, showLoading, hideLoading } from './actions';

import { RootState } from '../../../store/store';
import { RoomService } from '../../auth/room';

const loadRoomMiddleware: Middleware<{}, RootState> = ({ dispatch }) => next => (action: any) => {
    next(action);

    if (action.type === LOAD_ROOM) {
        dispatch(showLoading())
        RoomService.loadRoom(action.payload)
            .then(result => {
                dispatch(loadRoomSuccess(result.data))
                dispatch(hideLoading())
            });
    }
}

export const roomMiddleware = [loadRoomMiddleware];